module.exports = "<main>\n  <router-outlet></router-outlet>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/triggers/triggers.component.html
// module id = 1616
// module chunks = 2